<template>
  <CustomModal
    v-if="true"
    id="my-quiz-modal"
    class="basic-modal my-quiz-modal"
    :isCustomFooter="true"
  >
    <div class="quiz-title" slot="modal-header">
      데일리 퀴즈 상세
      <div class="quiz-subtitle">
        검토 완료 이후 퀴즈 수정이 불가능합니다.
      </div>
    </div>
    <QuizPreview :quiz="quiz" />
    <div slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        취소
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        @click="$emit('ok')"
        :disabled="isActiveQuiz || isEndQuiz || isReviewCompletedQuiz"
      >
        수정
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="handleDeleteClick"
        :disabled="isActiveQuiz || isReviewCompletedQuiz"
      >
        <template v-if="!isLoading">삭제</template>
        <LoadingBounce v-else></LoadingBounce>
      </button>
    </div>
  </CustomModal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import QuizPreview from '../components/QuizPreview';
  import quiz from '../mixins/quiz';

  export default {
    name: 'my-quiz-modal',

    mixins: [
      quiz,
    ],

    props: {
      quiz: {
        type: Object,
        default: {},
      },
    },

    components: {
      QuizPreview,
    },

    methods: {
      ...mapActions([
        'deleteQuiz',
      ]),

      async handleDeleteClick() {
        if (!this.quiz.id) {
          return;
        }

        await this.deleteQuiz(this.quiz.id);
        await this.$emit('cancel');
      },
    },

    computed: {
      ...mapGetters({
        isLoading: 'isLoadingQuiz',
      }),

      getQuizSet() {
        return this.quiz.quiz_set || {};
      },

      isActiveQuiz() {
        return this.getQuizState(this.getQuizSet).value === 'active';
      },

      isEndQuiz() {
        return this.getQuizState(this.getQuizSet).value === 'end';
      },

      isReviewCompletedQuiz() {
        return this.getQuizState(this.getQuizSet).value === 'review_completed';
      },
    },

  };
</script>

<style lang="scss" scoped>
  .my-quiz-modal {
    .quiz-title {
      .quiz-subtitle {
        color: rgba(0, 0, 0, 0.26);
        font-size: 12px;
      }
    }

    .btn-danger {
      background-color: #e91e63;
      color: #ffffff;
    }

  }
</style>



// WEBPACK FOOTER //
// src/app/my-quizzes/components/MyQuizModal.vue